import { DataTags } from '../../shared/constants.js';
import { mainApi } from '../main/api.js';
import { playbookApi } from '../playbook/api.js';
import { RootState, Selectors } from '../state.js';
import { TD } from '../types.js';

import { playEditorActions } from './index.js';

let newPlayId = 0;
export const createPlay = (
    type: string,
    sport: string,
    name?: string,
    description = '',
    tags: string[] = [],
    flipField = false,
    formation?: FormationDefinition
) => {
    return async (dispatch: TD, getState: () => RootState) => {
        const playbookId = Selectors.playbookId(getState());

        newPlayId += 1;
        const id = `__${newPlayId}`;
        dispatch(
            playEditorActions.CreatePlay({
                id,
                type,
                sport,
                name,
                description,
                tags,
                viewOptions: { flipField },
            })
        );

        if (formation) {
            dispatch(playEditorActions.ApplyFormation(formation));
        }

        playbookApi.util.invalidateTags([{ type: DataTags.PLAYLIST_ITEM, id: `${playbookId}_LIST` }]);
    };
};

export const setVideoLink = (videoLink: string) => {
    return async (dispatch: TD, getState: () => RootState) => {
        dispatch(
            playEditorActions.UpdatePlay({
                videoLink,
            })
        );

        const play = Selectors.play(getState());

        if (videoLink !== '') {
            const {
                data: { thumbnailUrl },
            } = await dispatch(mainApi.endpoints.getVideoDetails.initiate({ videoLink }));

            dispatch(
                playEditorActions.UpdatePlay({
                    thumbnailUrl,
                    tags: [...(play.tags ?? []), 'Video'],
                })
            );
        } else {
            dispatch(
                playEditorActions.UpdatePlay({
                    thumbnailUrl: null,
                    tags: play.tags?.filter((tag: string) => tag !== 'Video'),
                })
            );
        }
    };
};
